import React, { useState } from 'react';
import './styles.css';

const Settings = ({meta}) => {
  const [deliveryType, setDeliveryType] = useState('');
  const [name, setName] = useState({
    EN: '',
    AR: '',
    ES: '',
    FR: '',
  });

  return (
    <div className="e-delivery-container">
      <aside className="sidebar">
        <h2 className="sidebar-title">eDelivery</h2>
        <ul className="sidebar-menu">
          <li>Dashboard</li>
          <li>Order</li>
          <li>Map View</li>
          <li>Earning</li>
          <li>Menu</li>
          <li>Users</li>
          <li className="active">Delivery Info</li>
        </ul>
      </aside>
      
      <main className="main-content">
        <header className="main-header">
          <h1>Delivery</h1>
          <div className="breadcrumb">Home | Delivery Info | Delivery</div>
        </header>
        
        <div className="delivery-form">
          <div className="form-grid">
            <div className="fast-food-image">
              <img src="/path-to-fast-food-image.png" alt="Fast Food" />
            </div>
            
            <div className="form-fields">
              <div className="form-field">
                <label>Delivery Type</label>
                <select 
                  value={deliveryType}
                  onChange={(e) => setDeliveryType(e.target.value)}
                >
                  <option value="">Select Delivery Type</option>
                  {/* Add other options here */}
                </select>
              </div>
              
              <div className="checkbox-group">
                <div className="checkbox-item">
                  <input type="checkbox" id="createCategory" />
                  <label htmlFor="createCategory">Store can create category of sub category?</label>
                </div>
                <div className="checkbox-item">
                  <input type="checkbox" id="editOrder" />
                  <label htmlFor="editOrder">Store can edit order?</label>
                </div>
                <div className="checkbox-item">
                  <input type="checkbox" id="business" />
                  <label htmlFor="business">Business</label>
                </div>
              </div>
              
              <div className="default-image">
                <h3>Default Image</h3>
                <img src="/path-to-fast-food-image.png" alt="Default Fast Food" />
              </div>
            </div>
          </div>
          
          <div className="name-section">
            <h3>Name</h3>
            <div className="language-inputs">
              {['EN', 'AR', 'ES', 'FR'].map((lang) => (
                <input
                  key={lang}
                  type="text"
                  placeholder={lang}
                  value={name[lang]}
                  onChange={(e) => setName({ ...name, [lang]: e.target.value })}
                />
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Settings;